// User field validator

export default ({ mandatory = false, customError = null }) => ({
  presence: mandatory && {
    allowEmpty: !mandatory,
    message: customError && `^${customError}`
  }
});
